<template>
    <div>
      <div class="cs-top">
        <p class="cs-top-text" tabindex="0">무엇을 도와드릴까요?</p>
        <form class="cs-top-input">
          <fieldset>
            <legend>자주 묻는 질문 FAQ 검색 양식</legend>
            <label>
              <input type="text"
                     maxlength="50"
                     v-on:input="searchWord = $event.target.value"
                     :value="searchWord"
                     @keydown.enter.prevent="goSearchWord()"
                     placeholder="궁금하신 점이 있다면 검색 또는 도움말 카테고리를 선택하세요. (최대 50자)">
              <button type="button" @click="goSearchWord()" class="cs-search-btn">검색</button>
            </label>
          </fieldset>
        </form><!--cs-top-input//-->
        <div class="faq-top">
          <p class="faq-top-tit" tabindex="0">자주하는 질문</p>
          <ul class="faq-top-list">
            <template v-for="(recommendItem, index) in recommendList" >
              <li :key="index"><a href="#" @click.prevent="recommendFaq(recommendItem.searchkeyword)">{{recommendItem.displaykeywords}}</a></li>
            </template>
          </ul>
        </div>
      </div><!--cs-top//-->

      <ul v-if="filterList" class="cs-2depth">
        <li :class="setFilterCss('')"><button @click="faqPageMove('')">전체</button></li>
        <li v-for="(filterItem, index) in filterList" :key="index" :class="setFilterCss(filterItem.id)"><button @click="faqPageMove(filterItem.id)">{{filterItem.text}}</button></li>
      </ul>

      <template v-if="!isLoading && isListCheck">
        <ul class="cs-table">
          <li v-if="selectedFaq" :id="'li_'+selectedFaq.faqid" class="cs-table-open">
            <button @click="setFaqDetail(selectedFaq.faqid)" class="cs-tit-wrap">
              <strong class="cs-type">{{selectedFaq.faqtypetext}}</strong>
              <span class="cs-tit" v-html="setWordChange(selectedFaq.faqtitle)"></span>
              <span v-if="selectedFaq.faqid === selectedFaqId" class="a11y-hidden">닫기</span>
              <span v-else class="a11y-hidden">열기</span>
            </button>
            <div :id="'detail_'+selectedFaq.faqid" class="cs-desc" :tabindex="selectedFaq.faqid === selectedFaqId ? '0' : '-1'" v-html="selectedFaq.content"></div>
          </li>
          <template v-for="(faqItem, index) in faqList">
            <li :key="index" v-if="faqItem.faqid" :id="'li_'+faqItem.faqid">
              <button @click="setFaqDetail(faqItem.faqid)" class="cs-tit-wrap">
                <strong class="cs-type">{{faqItem.faqtypetext}}</strong>
                <span class="cs-tit" v-html="setWordChange(faqItem.faqtitle)"></span>
                <span v-if="faqItem.faqid === selectedFaqId" class="a11y-hidden">닫기</span>
                <span v-else class="a11y-hidden">열기</span>
              </button>
              <div :id="'detail_'+faqItem.faqid" class="cs-desc" :tabindex="faqItem.faqid === selectedFaqId ? '0' : '-1'"></div>
            </li>
          </template>
        </ul>
        <button type="button" v-if="moreCheck" @click="getFaqList('more')" class="cs-more">
          <span>더보기</span>
        </button>
      </template>

      <div v-else-if="!isLoading && searchWord" class="cs-empty">
        <img src="../../assets/images/customer/icon-error-74.png" alt="에러 아이콘"/>
        <p><span class="col-purple">{{$route.query.searchWord}}</span>'에 대한 FAQ가 없습니다.</p>
      </div>

      <div v-else-if="!isLoading" class="cs-empty">
        <img src="../../assets/images/customer/icon-error-74.png" alt="에러 아이콘"/>
        <p>검색된 FAQ가 없습니다.</p>
      </div>
    </div>
</template>

<script>
import { setReplaceAll, scrollTop, titleTagNameChange } from '@/common/utils/common'
import { getFaqsDetail, getFilters, getSearchFaq, getFaqs, getFaqsRecommend } from '@/common/utils/request'
import queryString from '@/common/utils/querystring'
import _ from 'lodash'
export default {
  name: 'FAQ',
  data () {
    return {
      data: true, // 임시 웨이브온 flag 값
      filterList: undefined,
      filterBtn: false,
      filterTitle: '전체',
      filterId: '',
      faqList: [],
      faqId: '',
      offset: 0,
      limit: 10,
      orderby: 'new',
      isListCheck: false,
      moreCheck: true,
      pageNum: 1,
      recommendList: [],
      selectedFaq: undefined,
      addList: [],
      isLoading: true,
      selectedFaqId: ''
    }
  },
  methods: {
    // 필터 선택 CSS
    setFilterCss (tempId) {
      return tempId === this.filterId ? 'cs-2depth-on' : ''
    },
    // Faq 조회 페이지 이동
    faqPageMove (strFilterId) {
      this.$router.push({
        query: {
          filterId: strFilterId,
          searchWord: this.searchWord
        }
      })
    },
    // Faq 상세정보 조회
    setFaqDetail (faqId) {
      this.selectedFaqId = faqId
      let i = 0
      const arrOpenClass = document.getElementsByClassName('cs-table-open')
      const toggleClass = document.getElementById('li_' + faqId).className
      if (toggleClass !== '') {
        this.selectedFaqId = ''
        document.getElementById('li_' + faqId).className = ''
      } else {
        // Faq리스트 조회
        getFaqsDetail({ faqid: faqId }).then((response) => {
          for (i = 0; i < arrOpenClass.length; i++) {
            arrOpenClass[i].className = ''
          }
          document.getElementById('detail_' + faqId).innerHTML = response.data.content
          document.getElementById('li_' + faqId).className = 'cs-table-open'
        })
      }
    },
    // 검색어 강조
    setWordChange (content) {
      const querySearchWord = _.get(this.$route, 'query.searchWord', '')
      const changeWord = '<span class="col-purple">' + querySearchWord + '</span>'
      let tmpContent = content
      if (querySearchWord !== '') {
        tmpContent = setReplaceAll(content, querySearchWord, changeWord)
      }
      return tmpContent
    },
    // FaqList 조회
    getFaqList (tempType) {
      // 검색어 조회 시
      if (tempType !== 'more') this.isLoading = true
      const offset = (this.pageNum - 1) * this.limit
      const getData = response => response.data
      const addData = data => { this.addList = _.get(data, 'list', []); return data }
      const getFaqList = data => { this.faqList = tempType === 'more' && this.addList ? this.faqList.concat(this.addList) : this.addList; return data }
      const isListCheck = (data) => { this.isListCheck = (this.faqList && this.faqList.length > 0); return data }
      const moreCheck = (data) => { this.moreCheck = (this.isListCheck && this.limit < _.get(data, 'pagecount', '1')); return data }
      const pageNum = () => { this.pageNum = this.isListCheck ? this.pageNum + 1 : this.pageNum }
      const loadComplete = () => { if (tempType !== 'more') this.isLoading = false }
      if (this.searchWord && this.searchWord !== '') {
        getSearchFaq({ type: this.filterId === '' ? 'all' : this.filterId, keyword: this.searchWord, offset, limit: this.limit, orderby: this.orderby })
          .then(getData).then(addData).then(getFaqList).then(isListCheck).then(moreCheck).then(pageNum).then(loadComplete)
      } else {
        getFaqs({ type: this.filterId === '' ? 'all' : this.filterId, faqid: '', offset, limit: this.limit, orderby: this.orderby })
          .then(getData).then(addData).then(getFaqList).then(isListCheck).then(moreCheck).then(pageNum).then(loadComplete)
      }
    },
    // 검색어 조회 페이지 이동
    goSearchWord () {
      this.$router.push({
        query: {
          filterId: this.filterId,
          searchWord: this.searchWord
        }
      })
    },
    getFaqsRecommend () {
      getFaqsRecommend().then((response) => {
        this.recommendList = response.data.list
      })
    },
    getSelectedFaq (faqId) {
      getFaqsDetail({ faqid: faqId }).then((response) => {
        this.selectedFaq = response.data
      })
    },
    recommendFaq (recommendId) {
      this.$router.push({
        query: {
          faqId: recommendId
        }
      })
    },
    setData () {
      getFilters({ type: 'faqcategory' }).then((response) => {
        this.filterList = response.data.faqcategory
      })
      scrollTop()
    },
    initialized () {
      this.searchWord = queryString.getQueryParamValue(this.$route, 'searchWord', '')
      this.filterId = queryString.getQueryParamValue(this.$route, 'filterId', '')
      this.faqId = queryString.getQueryParamValue(this.$route, 'faqId')
      this.selectedFaqId = this.faqId
      this.pageNum = 1
      this.faqList = []
      this.selectedFaq = undefined
    }
  },
  created () {
    this.initialized()
    this.setData()
    // 자주하는 질문
    this.getFaqsRecommend()
    // FaqList 조회
    this.getFaqList('base')
    // 검색 또는 자주하는 질문으로 선택된 faq가 존재하는 경우
    if (this.faqId !== '') {
      this.getSelectedFaq(this.faqId)
    }
    titleTagNameChange('FAQ : 웨이브 고객센터')
  },
  watch: {
    $route (to, from) {
      this.initialized()
      this.getFaqList(this.filterId)
      if (this.faqId !== '') {
        this.getSelectedFaq(this.faqId)
      }
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>
<style lang="scss" src="@/assets/scss/category/service.scss"></style>
